import { render, staticRenderFns } from "./StreamerDetail.vue?vue&type=template&id=a3f58134&scoped=true"
import script from "./StreamerDetail.vue?vue&type=script&lang=js"
export * from "./StreamerDetail.vue?vue&type=script&lang=js"
import style0 from "./StreamerDetail.vue?vue&type=style&index=0&id=a3f58134&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3f58134",
  null
  
)

export default component.exports